import React from 'react';
import { Phone, MessageSquare, Mail, Chrome, Eye, EyeOff, Fingerprint } from 'lucide-react';

const PhoneLoginModal = ({
  mobile,
  setMobile,
  password,
  checkPasswordStrength,
  passwordStrength,
  showPassword,
  setShowPassword,
  sendOTPForLogin,
  sendOTP,
  loginMethod,
  setLoginMethod,
  handleEmailLogin,
  rememberMe,
  setRememberMe,
  handleSocialLogin,
  biometricEnabled,
  handleBiometricLogin,
  showForgotPassword,
  showSignUp
}) => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center z-50 p-2 sm:p-4 overflow-y-auto">
      <div className="bg-white w-full max-w-md rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-2xl my-4 sm:my-8">
        <div className="text-center mb-6 sm:mb-8">
          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
            <span className="text-3xl sm:text-4xl">🥛</span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">Welcome!</h1>
          <p className="text-sm sm:text-base text-gray-600">Sign in to continue</p>
        </div>

        {/* Biometric Login Option */}
        {biometricEnabled && (
          <div className="mb-4 sm:mb-6">
            <button
              onClick={handleBiometricLogin}
              className="w-full bg-gradient-to-r from-purple-500 to-purple-600 text-white py-3 sm:py-4 rounded-xl font-semibold flex items-center justify-center gap-2 sm:gap-3 hover:from-purple-600 hover:to-purple-700 transition-all shadow-lg text-sm sm:text-base"
            >
              <Fingerprint size={20} className="sm:w-6 sm:h-6" />
              Sign in with Biometrics
            </button>
            <div className="flex items-center gap-3 my-3 sm:my-4">
              <div className="flex-1 h-px bg-gray-300"></div>
              <span className="text-gray-500 text-xs sm:text-sm">OR</span>
              <div className="flex-1 h-px bg-gray-300"></div>
            </div>
          </div>
        )}

        {loginMethod === 'phone' && (
          <>
            <div className="mb-4 sm:mb-6">
              <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                Enter Mobile Number
              </label>
              <div className="flex items-center border-2 border-gray-200 rounded-xl px-3 py-2.5 sm:px-4 sm:py-3 focus-within:border-blue-500 transition-all">
                <span className="text-gray-600 font-medium mr-2 text-sm sm:text-base">+91</span>
                <input
                  type="tel"
                  maxLength="10"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value.replace(/\D/g, ''))}
                  placeholder="Enter 10-digit number"
                  className="flex-1 outline-none text-gray-800 text-base sm:text-lg"
                />
              </div>
            </div>
            {/* Password Input and OTP Buttons 
            <div className="mb-4 sm:mb-6">
              <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => checkPasswordStrength(e.target.value)}
                  className="w-full border-2 border-gray-200 rounded-xl px-3 py-2.5 sm:px-4 sm:py-3 pr-10 sm:pr-12 outline-none focus:border-blue-500 transition-all text-sm sm:text-base"
                  id="password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 sm:right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? <EyeOff size={18} className="sm:w-5 sm:h-5" /> : <Eye size={18} className="sm:w-5 sm:h-5" />}
                </button>
              </div>
              
              {password && passwordStrength.score > 0 && (
                <div className="mt-2">
                  <div className="flex gap-1 mb-1">
                    {[1, 2, 3, 4, 5].map((level) => (
                      <div
                        key={level}
                        className={`h-1 flex-1 rounded-full transition-all ${
                          level <= passwordStrength.score
                            ? passwordStrength.color
                            : 'bg-gray-200'
                        }`}
                      />
                    ))}
                  </div>
                  <p className="text-xs text-gray-600">
                    Password strength: <span className="font-semibold">{passwordStrength.label}</span>
                  </p>
                </div>
              )}
              
              <button 
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  showForgotPassword();
                }}
                className="text-xs sm:text-sm text-blue-600 hover:underline mt-2"
              >
                Forgot Password?
              </button>
            </div>
            */}

            <div className="space-y-2 sm:space-y-3 mb-4 sm:mb-6">
              <button
                onClick={() => sendOTPForLogin('sms')}
                disabled={mobile.length !== 10}
                className="w-full bg-blue-600 text-white py-3 sm:py-4 rounded-xl font-semibold flex items-center justify-center gap-2 sm:gap-3 hover:bg-blue-700 transition-all disabled:bg-gray-300 disabled:cursor-not-allowed text-sm sm:text-base"
              >
                <MessageSquare size={18} className="sm:w-5 sm:h-5" />
                Send OTP via SMS
              </button>

              <button
                onClick={() => sendOTP('whatsapp')}
                disabled={mobile.length !== 10}
                className="w-full bg-green-600 text-white py-3 sm:py-4 rounded-xl font-semibold flex items-center justify-center gap-2 sm:gap-3 hover:bg-green-700 transition-all disabled:bg-gray-300 disabled:cursor-not-allowed text-sm sm:text-base"
              >
                <MessageSquare size={18} className="sm:w-5 sm:h-5" />
                Send OTP via WhatsApp
              </button>
            </div>
          </>
        )}

        {loginMethod === 'email' && (
          <>
            <div className="mb-3 sm:mb-4">
              <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                Email Address
              </label>
              <input
                type="email"
                placeholder="your.email@example.com"
                className="w-full border-2 border-gray-200 rounded-xl px-3 py-2.5 sm:px-4 sm:py-3 outline-none focus:border-blue-500 transition-all text-sm sm:text-base"
                id="email-input"
              />
            </div>

            <div className="mb-4 sm:mb-6">
              <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => checkPasswordStrength(e.target.value)}
                  className="w-full border-2 border-gray-200 rounded-xl px-3 py-2.5 sm:px-4 sm:py-3 pr-10 sm:pr-12 outline-none focus:border-blue-500 transition-all text-sm sm:text-base"
                  id="password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 sm:right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? <EyeOff size={18} className="sm:w-5 sm:h-5" /> : <Eye size={18} className="sm:w-5 sm:h-5" />}
                </button>
              </div>
              
              <button 
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  showForgotPassword();
                }}
                className="text-xs sm:text-sm text-blue-600 hover:underline mt-2"
              >
                Forgot Password?
              </button>
            </div>

            <button
              onClick={() => {
                const email = document.getElementById('email-input').value;
                const pwd = document.getElementById('password-input').value;
                handleEmailLogin(email, pwd);
              }}
              className="w-full bg-blue-600 text-white py-3 sm:py-4 rounded-xl font-semibold hover:bg-blue-700 transition-all mb-3 sm:mb-4 text-sm sm:text-base"
            >
              Sign In with Email
            </button>

            <div className="flex items-center gap-2 mb-3 sm:mb-4">
              <input
                type="checkbox"
                id="remember-me"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <label htmlFor="remember-me" className="text-xs sm:text-sm text-gray-700">
                Remember me on this device
              </label>
            </div>
          </>
        )}

        <div className="flex items-center gap-3 my-4 sm:my-6">
          <div className="flex-1 h-px bg-gray-300"></div>
          <span className="text-gray-500 text-xs sm:text-sm">OR</span>
          <div className="flex-1 h-px bg-gray-300"></div>
        </div>

        <div className="space-y-2 sm:space-y-3 mb-4 sm:mb-6">
          <button
            onClick={() => handleSocialLogin('Google')}
            className="w-full bg-white border-2 border-gray-300 text-gray-700 py-2.5 sm:py-3 rounded-xl font-semibold flex items-center justify-center gap-2 sm:gap-3 hover:bg-gray-50 transition-all text-sm sm:text-base"
          >
            <Chrome size={18} className="sm:w-5 sm:h-5 text-red-500" />
            Continue with Google
          </button>

          <button
            onClick={() => handleSocialLogin('Facebook')}
            className="w-full bg-blue-600 text-white py-2.5 sm:py-3 rounded-xl font-semibold flex items-center justify-center gap-2 sm:gap-3 hover:bg-blue-700 transition-all text-sm sm:text-base"
          >
            <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            Continue with Facebook
          </button>
        </div>

        <div className="flex gap-2 justify-center mb-3 sm:mb-4">
          <button
            onClick={() => setLoginMethod('phone')}
            className={`px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg text-xs sm:text-sm font-medium transition-all ${
              loginMethod === 'phone'
                ? 'bg-blue-100 text-blue-600'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            <Phone size={14} className="inline mr-1 sm:w-4 sm:h-4" />
            Phone
          </button>
          <button
            onClick={() => setLoginMethod('email')}
            className={`px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg text-xs sm:text-sm font-medium transition-all ${
              loginMethod === 'email'
                ? 'bg-blue-100 text-blue-600'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            <Mail size={14} className="inline mr-1 sm:w-4 sm:h-4" />
            Email
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center">
          By continuing, you agree to our Terms of Service and Privacy Policy
        </p>

        <p className="text-xs sm:text-sm text-gray-600 text-center mt-3 sm:mt-4">
          Don't have an account?{' '}
          <button 
            type="button"
            onClick={(e) => {
              e.preventDefault();
              showSignUp();
            }}
            className="text-blue-600 hover:underline font-semibold"
          >
            Sign Up
          </button>
        </p>
      </div>
    </div>
  );
};

export default PhoneLoginModal;